import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Section } from '../ui/Section';
import { Plus, Minus } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: 'Do I need a lot of cash to start?',
    a: 'No. Most people use the Bridge Strategy we outline to buy with minimal personal savings.'
  }, {
    q: 'Is it dangerous?',
    a: 'Not if you follow the Title-First checklist to avoid hidden debts.'
  }, {
    q: 'Can I do this in any state?',
    a: 'Yes, though the rules vary (we cover the differences between states).'
  }, {
    q: 'What if someone is living there?',
    a: 'We provide the "Cash for Keys" framework to handle occupants professionally.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section theme="black" className="border-b border-gold-hairline" data-id="element-17">
      <div className="max-w-3xl mx-auto" data-id="element-18">
        <h2 className="text-3xl md:text-4xl font-serif font-medium mb-14 text-center text-bone" data-id="element-19">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-20">
          {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className={`bg-onyx border border-gold-hairline transition-colors duration-300 ${isOpen ? 'border-l-2 border-l-gold' : ''}`} data-id="element-21">
                <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full flex items-center justify-between p-6 md:p-8 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gold" aria-expanded={isOpen} data-id="element-22">
                  <span className="text-lg md:text-xl font-serif font-medium text-bone pr-8" data-id="element-23">
                    {faq.q}
                  </span>
                  <div className="shrink-0 text-gold" data-id="element-24">
                    {isOpen ? <Minus className="w-5 h-5" data-id="element-25" /> : <Plus className="w-5 h-5" data-id="element-26" />}
                  </div>
                </button>

                <AnimatePresence data-id="element-27">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-28">
                      <div className="p-6 md:p-8 pt-0 text-bone-muted text-lg leading-relaxed border-t border-gold-hairline mx-6 md:mx-8 px-0 mt-2" data-id="element-29">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </Section>;
}